import { doc, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from '../firebase/firebase';
import { DEFAULT_CLASSES } from './classes';

const ALL = DEFAULT_CLASSES.map((item) => item.id);
const FROM_3 = ['3eme', '4eme', '5eme', '6eme'];
const FROM_4 = ['4eme', '5eme', '6eme'];
const FROM_5 = ['5eme', '6eme'];

export const DEFAULT_SUBJECTS = [
  { id: 'arabe', name: 'Arabe', classIds: ALL, order: 10 },
  { id: 'mathematiques', name: 'Mathématiques', classIds: ALL, order: 20 },
  { id: 'eveil_scientifique', name: 'Éveil scientifique / Sciences', classIds: ALL, order: 30 },
  { id: 'education_islamique', name: 'Éducation islamique', classIds: ALL, order: 40 },

  { 
    id: 'histoire_geographie_education_civique', 
    name: 'Histoire / Géographie / Éducation civique', 
    classIds: ALL, 
    order: 50 
  },

  { id: 'arts', name: 'Dessin', classIds: ALL, order: 60 },
  { id: 'musique', name: 'Éducation musicale', classIds: ALL, order: 70 },
  { id: 'sport', name: 'Sport', classIds: ALL, order: 80 },

  { id: 'francais', name: 'Français', classIds: ALL, order: 90 },
  { id: 'anglais', name: 'Anglais', classIds: ALL, order: 100 },
  { id: 'technologie', name: 'Technologie', classIds: ALL, order: 110 }
];

export async function initializeSchoolCatalog(userUid = null) {
  const now = serverTimestamp();
  await Promise.all([
    ...DEFAULT_CLASSES.map((schoolClass) => setDoc(
      doc(db, 'classes', schoolClass.id),
      {
        ...schoolClass,
        public: true,
        updatedAt: now,
        updatedByUid: userUid
      },
      { merge: true }
    )),
    ...DEFAULT_SUBJECTS.map((subject) => setDoc(
      doc(db, 'subjects', subject.id),
      {
        ...subject,
        status: 'active',
        updatedAt: now,
        updatedByUid: userUid
      },
      { merge: true }
    ))
  ]);
}
